import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { exitImpersonation } from '../../../store/Admin';
import './Workspaces.css';

const ExitImpersonate = ({ exitImpersonation }) => {
  const [impersonationContext, setImpersonationContext] = useState(null);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Check for impersonation context on mount and when storage changes
    const checkImpersonation = () => {
      const context = localStorage.getItem('impersonationContext');
      if (context) {
        try {
          setImpersonationContext(JSON.parse(context));
        } catch (e) {
          console.error('Invalid impersonation context', e);
          setImpersonationContext(null);
        }
      } else {
        setImpersonationContext(null);
      }
    };

    checkImpersonation();

    // Listen for storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'impersonationContext') {
        checkImpersonation();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically in case localStorage is updated in same tab
    const interval = setInterval(checkImpersonation, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const handleExitImpersonation = () => {
    if (isExiting || !impersonationContext) return;
    
    setIsExiting(true);
    
    // Call the exit impersonation action with the original admin token
    exitImpersonation({
      originalToken: impersonationContext.originalToken,
      callback: (success) => {
        if (success) {
          // Restore original token
          if (impersonationContext.originalToken) {
            localStorage.setItem('token', impersonationContext.originalToken);
          }
          
          // Clear impersonation context
          localStorage.removeItem('impersonationContext');
          
          // Force reload to refresh all components
          window.location.href = '/admin';
        } else {
          setIsExiting(false);
          console.error('Failed to exit impersonation');
        }
      }
    });
  };

  // Don't show if not in impersonation mode
  if (!impersonationContext) {
    return null;
  }

  const adminName = impersonationContext.adminName || 'Admin';
  const expiresAt = impersonationContext.expiresAt;
  
  // Calculate remaining time
  let remainingTime = '';
  if (expiresAt) {
    const now = new Date();
    const expires = new Date(expiresAt);
    const diff = expires - now;
    if (diff > 0) {
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      remainingTime = `${hours}h ${minutes}m remaining`;
    } else {
      remainingTime = 'Session expired';
    }
  }

  return (
    <div className="exit-impersonation-container">
      <Button 
        id="exit-impersonation-btn"
        className="exit-impersonation-btn"
        color="warning"
        onClick={handleExitImpersonation}
        disabled={isExiting}
      >
        <i className="fa fa-sign-out mr-2"></i>
        {isExiting ? 'Exiting...' : 'Exit Impersonation'}
      </Button>
      
      <UncontrolledTooltip 
        placement="left" 
        target="exit-impersonation-btn"
        delay={{ show: 100, hide: 100 }}
      >
        <div className="impersonation-tooltip">
          <div>{adminName}</div>
          {remainingTime && <small className="d-block mt-1">{remainingTime}</small>}
          <small className="d-block mt-1">Click to return to admin session</small>
        </div>
      </UncontrolledTooltip>
    </div>
  );
};

const mapDispatchToProps = {
  exitImpersonation
};

export default connect(null, mapDispatchToProps)(ExitImpersonate);